import { EducationalItem } from '@com-delta-idp/mnx-skymiles-educational-content-ui';
import { getGenericLabel, getLink } from '@com-delta-idp/mnx-skymiles-shared';
import {
  BorderType,
  DetailEntry,
  EntryItem
} from '@com-delta-omnichannel/aura';
import { Earn, Items } from '../models/educational-content-aem.interfaces';

export const getItems = (content: Items[]): EducationalItem[] => {
  const status: EducationalItem[] = [];
  let item = {} as EducationalItem;
  content.forEach((contentItem: Items) => {
    item = {
      detail: contentItem.description,
      entry: getEntryItem(contentItem),
      action: getLink(contentItem.actionLabel, contentItem.actionUrl)
    };
    if (contentItem?.earns && contentItem?.earns.length > 0) {
      item.tierMiles = getTierMiles(contentItem.earns);
    }
    status.push(item);
  });
  return status;
};

const getEntryItem = (item: Items): EntryItem => {
  const title = getTitle(item) || '';
  return {
    content: getGenericLabel(title, ''),
    icon: item.imageSrc || '',
    state: '',
    value: [],
    border: 'none' as BorderType,
    ariaLabel: { icon: item.imageAlt ? item.imageAlt : '' }
  };
};

const getTitle = (content: Items): string | undefined => {
  return content.earnTitle ? content.earnTitle : content.availTitle;
};

const getTierMiles = (content: Earn[]): DetailEntry[] => {
  const tierMiles: DetailEntry[] = [];
  let tierMilesItem = {} as DetailEntry;
  content.forEach((item: Earn) => {
    tierMilesItem = {
      info: null,
      icon: item.imageSrc,
      title: item.title,
      type: 'mixed',
      value: item.value
    };
    tierMiles.push(tierMilesItem);
  });
  return tierMiles;
};
